/*
 * @Description: 报告摘要
 * @Author: yy
 * @Date: 2019-05-31 14:47:28
 * @LastEditors: yy
 * @LastEditTime: 2019-09-24 15:35:09
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './p2.css';

import ExportTitie from '../../../components/ExportTitle/ExportTitle';
import Summary from '../../../components/Summary/Summary';
import { getSessionQuery, toThousands } from '../../../utils';
import { getP2NumberInfo } from '../../../controller';


class P2 extends React.Component {
  constructor () {
    super();

    this.state = {
      industry: '',
      contentNum: 0,
      db: 0,
      dbRanking: 0,
      favorability: '',
      kol: 0,
      mind: 0,
      mindRanking: 0
    };
  }

  componentDidMount () {
    this.getData();
  }

  getQuery () {
    const query = getSessionQuery('query');
    const result = {
      brandName: query.brand,
      startDate: query.beginTime,
      statisDate: query.endTime
    }
    if (query.isCustom === '1') {
      result.areaIndustry = query.industry
      result.competingBrands = query.competingGoods.map(item => item.value).join(',')
    }
    return result
  }

  getData () {
    const query = this.getQuery();
    this.getP2NumberInfo(query);
  }


  getP2NumberInfo(query) {
    if (!query.brandName || !query.startDate || !query.statisDate) {
      return alert('请输入正确参数')
    }
    getP2NumberInfo(Object.assign({report: true}, query))
      .then(data => {
        if (data) {
          this.setState({
            industry: data.industry,
            contentNum: toThousands(data.contentNum),
            db: toThousands(data.db),
            dbRanking: data.dbRanking,
            favorability: data.favorability,
            kol: toThousands(data.kol),
            mind: data.mind,
            mindRanking: data.mindRanking
          })
          
          sessionStorage.setItem('industry', data.industry);
        }
      })
  }

  render() {
    const state = this.state;
    return (
      <div className={s.root}>
        <div className={s.titleContent}>
          <ExportTitie>· 报告摘要</ExportTitie>
        </div>
        <div className={s.summaryContent}>
          <Summary>
            <div>
              数字品牌价值
            </div>
            <div className={s.dbText}>
              {state.db}
              <em>DB</em>
            </div>
            <div>
              总榜排名
            </div>
            <div>
              No.{state.dbRanking}
            </div>
          </Summary>
          <Summary>
            <div style={{whiteSpace: 'nowrap'}}> {state.industry}行业 </div>
            <div> 心智占有率 </div>
            <div className={s.dbText}> {state.mind}% </div>
            <div> 细分领域排名 </div>
            <div> No.{state.mindRanking} </div>
          </Summary>
          <Summary>
            <div> 相关内容总条数 </div>
            <div className={s.dbText}> {state.contentNum} </div>
          </Summary>
          <Summary>
            <div> KOL总参与人次 </div>
            <div className={s.dbText}> {state.kol} </div>            
          </Summary>
          <Summary>
            <div> 用户好感度 </div>
            <div className={s.dbText}> {state.favorability} </div>
          </Summary>
        </div>

        <div className={s.briefAnalysis}>
          <ExportTitie>· 简要分析</ExportTitie>
        </div>

        <ol  className={s.analysis}>
          {/* <li>本周优信二手车的数字品牌价值走势较平稳，本报告期末（2月9日）在二手车交易领域心智占有率较期初（2月3日）上升0.29%，居行业首位。</li>
          <li>优信二手车品牌的受众整体情感倾向是：顺意群体占44.24% （低于全网顺意均值的73.99%），中立群体占10.12% （低于全网中立均值的15.89%），逆意群体占45.63% （高于全网逆意均值的10.11%）。本周优信顺意群体占比有所下降，逆意群体占比有所上升，主要受春节期间广告被大量吐槽影响，优信逆意群体中的KOL占比低于瓜子二手车、人人车，高于大搜车。</li>
          <li>本周，优信二手车好评类内容有346篇，负面评价文章数量上升至332篇，且负面文章主要围绕春节广告吐槽。其中，微博KOL@当时我就震惊了 发布的微博《#春节大型沙雕现场#“省省省省省省”“底底底底底底”相信我，看完这个视频后这两个字会在你脑袋里回音缭绕，余音袅袅袅袅...》共335次转发，369条评论，建议及时关注。</li>
          <li>重点竞品监测：瓜子二手车可能获得15亿美元融资引发大量关注；人人车春节广告同样被大量吐槽；大搜车合同陷阱的负面内容被集中大量报道，引发大量关注。</li> */}
        </ol>

      </div>
    );
  }
}

export default withStyles(s)(P2);



// WEBPACK FOOTER //
// src/routes/exportPDF/p2/p2.js